import React, { InputHTMLAttributes, ReactNode, useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';

interface ITextInput extends InputHTMLAttributes<HTMLInputElement> {
    error?: string;
    icon?: { icon: ReactNode; position: 'prefix' | 'suffix' }
};
export const TextInput = (props: ITextInput) => {
    const { error, icon, className = '', type, ...rest } = props;

    const [inputType, setInputType] = useState(type);

    const togglePassword = () => {
        setInputType(inputType === 'password' ? 'text' : 'password');
    };

    return (
        <div className="input-group">
            <div className={`input-group--input-wrapper ${error ? 'input-group--input-wrapper--error' : ''}`}>
                {icon?.position === 'prefix' && icon.icon}
                <input
                    className={className ?? ''}
                    type={inputType}
                    {...rest}
                />
                {icon?.position === 'suffix' && icon.icon}
                {type === 'password' && (
                    <button
                        type='button'
                        className='input-group--input-wrapper--password-toggle-btn'
                        onClick={togglePassword}
                    >
                        {inputType === 'password' ? <Eye /> : <EyeOff />}
                    </button>
                )}
            </div>
            {error && <p className='text-sm color--error'>{error}</p>}
        </div>
    );
};